import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setToggleInteriorHotspot, setIncrementClickedInterior } from '../../../Redux/Reducers/View360Reducer/View360ActionController';

export const useUspHotspot = (props) => {
  const dispatch = useDispatch();
  const [currentUspIndex, setCurrentUspIndex] = useState(0);
  
  // Update current USP index with proper state management
  const setCurrentUspIndexSafe = (newIndex) => {
    if (newIndex >= 0 && newIndex < combinedHotspotData.length) {
      setCurrentUspIndex(newIndex);
    }
  };
  const [combinedHotspotData, setCombinedHotspotData] = useState([]);
  const [modalListV3, setModalListV3] = useState([]);
  const [hotspotDataInteriorV3, setHotspotDataInteriorV3] = useState([]);
  
  const modalList = useSelector((state) => state.view360Reducer.modalList);
  const hotspotDataInterior = useSelector((state) => state.view360Reducer.hotspotDataInterior);
  const hotspotClickedIndex = useSelector((state) => state.view360Reducer.hotspotClickedIndex);
  const dropdownSelection = useSelector((state) => state.view360Reducer.dropdownSelection);
  const interiorHotspotIndex = useSelector(state => state.view360Reducer.interiorHotspotIndex);
  const toggleHotspotView = useSelector(state => state.view360Reducer.toggleHotspotView);
  const is360Index = useSelector(state => state.view360Reducer.is360Index);
  const is360IntIndex = useSelector(state => state.view360Reducer.is360IntIndex);

  const normalizeData = (interiorData, exteriorData) => {
    const normalizedExterior = exteriorData?.map(item => ({
      ...item,
      type: "EXT",
      hotspot_id: item.key,
      feature: item.heading
    }));

    const normalizedInterior = interiorData?.map(item => ({
      ...item,
      type: "INT",
      heading: item.heading || item.hotspot_id || item.feature || '',
      desc: item.desc || item.feature || '',
      url: item.url || item.hotspot_icon || '',
      key: item.key || item.hotspot_id || item._id || ''
    }));

    return [...normalizedExterior, ...normalizedInterior];
  };

  useEffect(() => {
    props?.setInteriorHotspotIndex(-1);
  }, []);

  useEffect(() => {
    let exteriorArray = [];
    let interiorArray = [];

    if(modalList?.size){
      exteriorArray = Array.from(modalList.entries())?.map(([key, value]) => ({
        key: key,
        ...value
      }));
      setModalListV3(exteriorArray);
    }

    if(hotspotDataInterior.length > 0){
      interiorArray = hotspotDataInterior;
      setHotspotDataInteriorV3(hotspotDataInterior);
    }

    const combined = normalizeData(interiorArray, exteriorArray);
    setCombinedHotspotData(combined);
  }, [modalList, hotspotDataInterior]);

  useEffect(() => {
    if(hotspotClickedIndex !== -1 && dropdownSelection === "EXT" && combinedHotspotData.length > 0){
      const extItems = combinedHotspotData.filter(item => item.type === "EXT");
      if(hotspotClickedIndex < extItems.length) {
        // Find the actual index in the combined array
        const extIndex = combinedHotspotData.findIndex((item, index) => 
          item.type === "EXT" && index === hotspotClickedIndex
        );
        if(extIndex !== -1) {
          setCurrentUspIndexSafe(extIndex);
        }
      }
    }
  }, [hotspotClickedIndex, combinedHotspotData, dropdownSelection]);

  useEffect(() => {
    if(interiorHotspotIndex !== -1 && dropdownSelection === "INT" && combinedHotspotData.length > 0){
      const extCount = combinedHotspotData.filter(item => item.type === "EXT").length;
      const intItems = combinedHotspotData.filter(item => item.type === "INT");
      
      if(interiorHotspotIndex < intItems.length) {
        // Calculate the correct combined index for interior items
        const combinedIndex = extCount + interiorHotspotIndex;
        if(combinedIndex < combinedHotspotData.length) {
          setCurrentUspIndexSafe(combinedIndex);
        }
      }
    }
  }, [interiorHotspotIndex, combinedHotspotData, dropdownSelection]);

  useEffect(() => {
    if(dropdownSelection === "INT") {
      if(interiorHotspotIndex === -1 && combinedHotspotData.length > 0) {
        const firstIntIndex = combinedHotspotData.findIndex(item => item.type === "INT");
      }
    }
  }, [dropdownSelection, combinedHotspotData, interiorHotspotIndex]);

  const handleNext = (e) => {
    e.stopPropagation();
    const currentItem = combinedHotspotData[currentUspIndex];
    
    if(!currentItem) return;
    
    const extItems = combinedHotspotData?.filter(item => item.type === "EXT") || [];
    const intItems = combinedHotspotData?.filter(item => item.type === "INT") || [];
    const extCount = extItems.length;
    const intCount = intItems.length;
    
    let nextIndex;
    
    if(currentItem.type === "EXT") {
      // For EXT items: they are at the beginning of array [0, 1, 2, ..., extCount-1]
      const nextExtIndex = (currentUspIndex + 1) % extCount;
      nextIndex = nextExtIndex;
      
      // Find the corresponding hotspot key in modalList for View360
      const nextItem = combinedHotspotData[nextIndex];
      if(nextItem && modalList && modalList.size > 0) {
        const modalListKeys = Array.from(modalList.keys());
        const modalListIndex = modalListKeys.findIndex(key => key === nextItem.key);
        
        if(modalListIndex !== -1) {
          setTimeout(() => {
            // Reset Redux state first to ensure change detection works
            props?.setIncrementClicked(-1);
            setTimeout(() => {
              props?.setIncrementClicked(modalListIndex);
            }, 10);
          }, 0);
        }
      }
    } else if(currentItem.type === "INT") {
      // For INT items: they start after EXT items [extCount, extCount+1, ..., extCount+intCount-1]
      const currentIntRelativeIndex = currentUspIndex - extCount;
      const nextIntRelativeIndex = (currentIntRelativeIndex + 1) % intCount;
      nextIndex = extCount + nextIntRelativeIndex;
      
      // Update View360 state for interior hotspots using relative index
      if(intCount > 1){
        setTimeout(() => {
          // Reset Redux state first to ensure change detection works
          props?.setIncrementClickedInterior(-1);
          setTimeout(() => {
            props?.setIncrementClickedInterior(nextIntRelativeIndex);
          }, 10);
        }, 0);
      }
    }
    
    // Update USP modal state immediately for responsive UI
    setCurrentUspIndexSafe(nextIndex);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    const currentItem = combinedHotspotData[currentUspIndex];
    
    if(!currentItem) return;
    
    const extItems = combinedHotspotData?.filter(item => item.type === "EXT") || [];
    const intItems = combinedHotspotData?.filter(item => item.type === "INT") || [];
    const extCount = extItems.length;
    const intCount = intItems.length;
    
    let prevIndex;
    
    if(currentItem.type === "EXT") {
      // For EXT items: they are at the beginning of array [0, 1, 2, ..., extCount-1]
      const prevExtIndex = currentUspIndex <= 0 ? extCount - 1 : currentUspIndex - 1;
      prevIndex = prevExtIndex;
      
      // Find the corresponding hotspot key in modalList for View360
      const prevItem = combinedHotspotData[prevIndex];
      if(prevItem && modalList && modalList.size > 0) {
        const modalListKeys = Array.from(modalList.keys());
        const modalListIndex = modalListKeys.findIndex(key => key === prevItem.key);
        
        if(modalListIndex !== -1) {
          setTimeout(() => {
            // Reset Redux state first to ensure change detection works
            props?.setDecrementClicked(-1);
            setTimeout(() => {
              props?.setDecrementClicked(modalListIndex);
            }, 10);
          }, 0);
        }
      }
    } else if(currentItem.type === "INT") {
      // For INT items: they start after EXT items [extCount, extCount+1, ..., extCount+intCount-1]
      const currentIntRelativeIndex = currentUspIndex - extCount;
      const prevIntRelativeIndex = currentIntRelativeIndex <= 0 ? intCount - 1 : currentIntRelativeIndex - 1;
      prevIndex = extCount + prevIntRelativeIndex;
      
      // Update View360 state for interior hotspots using relative index
      if(intCount > 1){
        setTimeout(() => {
          // Reset Redux state first to ensure change detection works
          props?.setDecrementClickedInterior(-1);
          setTimeout(() => {
            props?.setDecrementClickedInterior(prevIntRelativeIndex);
          }, 10);
        }, 0);
      }
    }
    
    // Update USP modal state immediately for responsive UI
    setCurrentUspIndexSafe(prevIndex);
  };

  // Navigation functions for collapsed modal
  const handleNextCollapsed = (e) => {
    e.stopPropagation();
    const nextIndex = currentUspIndex + 1 >= combinedHotspotData.length ? 0 : currentUspIndex + 1;
    setCurrentUspIndexSafe(nextIndex);
  };

  const handlePrevCollapsed = (e) => {
    e.stopPropagation();
    const prevIndex = currentUspIndex === 0 ? combinedHotspotData.length - 1 : currentUspIndex - 1;
    setCurrentUspIndexSafe(prevIndex);
  };

  // Toggle expand function
  const toggleExpand = (isExpanded, setIsExpanded) => {
    const currentItem = combinedHotspotData[currentUspIndex];
    
    if(isExpanded){
      // Clear all Redux state when closing
      props?.setIncrementClicked(-1);
      props?.setInteriorHotspotIndex(-1);
      props?.setHotspotClickedIndex(-1);
      setIsExpanded(false);
      props?.setToggleHotspotView(false);
      dispatch(setToggleInteriorHotspot(false));
      return;
    }

    if(currentItem) {
      const extCount = combinedHotspotData.filter(item => item.type === "EXT")?.length;
      
      if(currentItem.type === "INT") {
        props?.setToggleHotspotView(true);
        dispatch(setToggleInteriorHotspot(true));
        const interiorIndex = currentUspIndex - extCount;
        if(combinedHotspotData?.filter(item => item.type === "INT")?.length > 0){
          dispatch(setIncrementClickedInterior(interiorIndex));
        }
        
        if (props?.handleSelectThumbnail) {
          props?.handleSelectThumbnail(is360IntIndex,"360Int");
        }
      } else if(currentItem.type === "EXT") {
        const extIndex = currentUspIndex;
        if(combinedHotspotData?.filter(item => item.type === "EXT")?.length > 0){
          props?.setIncrementClicked(extIndex);
          setCurrentUspIndexSafe(extIndex);
        }
        if (props?.handleSelectThumbnail) {
          props?.handleSelectThumbnail(is360Index,'threeSixty');
        }
      }
      
      setTimeout(() => {
        setIsExpanded(true);
        if(currentItem.type === "EXT"){
          props?.setToggleHotspotView(true);
        }
        if(currentItem.type === "INT"){
          props?.setToggleHotspotView(true);
        }
      }, 100);
    }
  };

  // Function to handle initial hotspot clicks and open expanded modal
  const handleHotspotClick = (setIsExpanded) => {
    if(toggleHotspotView && combinedHotspotData.length > 0) {
      const currentItem = combinedHotspotData[currentUspIndex];
      
      if(currentItem) {
        const extCount = combinedHotspotData.filter(item => item.type === "EXT")?.length; 
        if(currentItem.type === "INT") {
          const interiorIndex = combinedHotspotData?.length - extCount;
          if(combinedHotspotData?.filter(item => item.type === "INT")?.length > 0){
            // props?.setIncrementClickedInterior(interiorIndex);
          }
          dispatch(setToggleInteriorHotspot(true));
          props?.setToggleHotspotView(true);
        } else if(currentItem.type === "EXT") {
          const extIndex = currentUspIndex;
          if(combinedHotspotData?.filter(item => item.type === "EXT")?.length > 0){
            // props?.setIncrementClicked(extIndex);
          }
        }
        
        // setTimeout(() => {
        //   if(currentItem.type === dropdownSelection){
        //     setIsExpanded(true);
        //   }
        // }, 100);
      }
    }
  };

  // Auto-cycling effect
  const useAutoCycle = (isExpanded, intervalTime = 5000) => {
    useEffect(() => {
      const interval = setInterval(() => {
        if (!isExpanded && combinedHotspotData.length > 0) {
          setCurrentUspIndex((prevIndex) => {
            return prevIndex === combinedHotspotData.length - 1 ? 0 : prevIndex + 1;
          });
        }
      }, intervalTime);
      return () => clearInterval(interval);
    }, [combinedHotspotData.length, isExpanded]);
  };

  const currentUsp = combinedHotspotData[currentUspIndex];
  const currentItemType = currentUsp?.type;
   
  return {
    currentUspIndex,
    setCurrentUspIndex,
    combinedHotspotData,
    currentUsp,
    modalListV3,
    hotspotDataInteriorV3,
    currentItemType,
    dropdownSelection,
    hotspotClickedIndex,
    interiorHotspotIndex,
    toggleHotspotView,
    handleNext,
    handlePrev,
    handleNextCollapsed,
    handlePrevCollapsed,
    toggleExpand,
    handleHotspotClick,
    useAutoCycle,
    normalizeData
  };
}; 